module.exports = [{"name":"Identity Platform Terms of Service","papers":[{"title":"Identity Platform Terms of Service","id":"auth0-ss-tos","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg","date":"October, 2019","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/2019/ss-tos-october.pdf"},{"action":"open","file":"https://cdn.auth0.com/website/legal/files/2019/ss-tos-october.pdf"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/ss-tos/data/ssTosPapers.json
// module id = 1540
// module chunks = 0